var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-quote-display parchment-f d-border"},_vm._l((_vm.block.blocks),function(block,blockIndex){return _c('BlockDisplay',{key:("scene_block_" + blockIndex),attrs:{"session":_vm.session,"block":block}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }